const $ = jQuery;

class FullWidthSlider {
    constructor() {
        this.setupSlider();
    }

    setupSlider() {
        const swiper = new Swiper( '.full-width-slider', {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 100,
            loop: true,
            pagination: {
                el: ".rounded-slider__dots",
                clickable: true,
            },
            navigation: {
                prevEl: '.rounded-slider__prev',
                nextEl: '.rounded-slider__next'
            },
            breakpoints: {
                960: {
                    slidesPerView: 1.8,
                },
              },
        });

        if ( Array.isArray( swiper ) ) {
            swiper.forEach(slider => {
                slider.on( 'resize', this.handleSlideResize.bind(this) );
                slider.on( 'slideChange', this.handleSlideChangeStart.bind(this) );
            });
        } else {
            swiper.on( 'resize', this.handleSlideResize.bind(this) );
            swiper.on( 'slideChange', this.handleSlideChangeStart.bind(this) );
        }
    }

    handleSlideResize(e) {
        if ( 'undefined' !== typeof e.$el[0] ) {
            const slideWidth = e.$el[0].querySelector('.swiper-slide-active').offsetWidth;
            e.$el[0].querySelector('.rounded-slider__pagination').setAttribute('style', `max-width: ${slideWidth}px` );
        }
    }

    handleSlideChangeStart( e ) {
        // Reset videos.
        e.$el[0].querySelectorAll('.video-embed').forEach( slider => {
            slider.classList.remove('video-embed--active');
            slider.querySelector('iframe').src = '';
        })
    }
}

new FullWidthSlider;